<div class="d-flex align-items-center flex-row error-indicator udex-py-4">
  <ui5-icon class="error-indicator__icon" name="message-information" design="Negative"></ui5-icon>
  <div class="udex-ms-12 error-indicator__placeholder"></div>
</div>
